module.exports = __webpack_public_path__ + "static/img/MC@2x.4eec98a1.jpg";